<template>
  <div class="container__payment-method-selector">
    <b-row class="cart__items-label font-weight-bold mx-0 w-100">
      <b-col ref="text__payment-title" class="pl-0 mb-3 text__payment-title">Payment methods</b-col>
    </b-row>

    <b-form-group
      class="form__payment m-0"
      :class="{ 'form__payment-required': $v.selectedPayment.$anyError }"
    >
      <!-- qr code -->
      <div class="container__payment-qr">
        <b-form-radio
          ref="radio__payment-qr"
          v-model="selectedPaymentMethod"
          value="QR_PAYMENT"
          size="sm"
        >
          <div ref="text__payment-qr" class="text__payment-qr">QR Payment</div>
          <b-img
            ref="img__payment-qr"
            :src="require('@/assets/icon-payment/payment-method/thai-qr-payment.svg')"
          ></b-img>
        </b-form-radio>
      </div>

      <!-- credit card -->
      <!-- <b-card>
        <b-form-radio v-model="selectedPaymentMethod" value="CREDIT_PAYMENT" size="sm">
          <div class="">Credit / Debit Card</div>
          <b-img :src="require('@/assets/icon-payment/payment-method/credit-payment.svg')"></b-img>
        </b-form-radio>
      </b-card> -->
    </b-form-group>
  </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

export default {
  model: {
    prop: 'modelValue',
    event: 'change'
  },

  props: {
    modelValue: {
      type: String,
      default: 'QR_PAYMENT'
    },
    totalAmount: {
      type: Number,
      default: 0
    }
  },
  validations() {
    return {
      selectedPayment: {
        required: requiredIf(() => this.totalAmount > 0 && !this.selectedPaymentMethod)
      }
    };
  },
  computed: {
    selectedPaymentMethod: {
      get() {
        return this.modelValue;
      },

      set(selectedPayment) {
        this.$emit('change', selectedPayment);
      }
    }
  }
};
</script>

<style lang="scss">
.text__payment-title {
  font-size: 20px;
}
.container__payment-method-selector {
  .container__payment-qr {
    border-radius: 1em;
    border: 1px solid #d1d2db;
    padding: 14px 24px;

    .text__payment-qr {
      margin-bottom: 8px;
    }
  }

  .form__payment div {
    display: grid;
    gap: 16px;
  }

  .form__payment-required {
    background: #ffffff !important;
    border: 1px solid #f83245 !important;
    border-radius: 0.65rem !important;
  }
}
</style>
